import React from 'react'
import { SvgIcon } from '@material-ui/core'

function DropDownIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        id='Vector'
        d='M8.20711 9.5C7.76165 9.5 7.53857 10.0386 7.85355 10.3536L11.6464 14.1464C11.8417 14.3417 12.1583 14.3417 12.3536 14.1464L16.1464 10.3536C16.4614 10.0386 16.2383 9.5 15.7929 9.5H8.20711Z'
      />
    </SvgIcon>
  )
}

export default DropDownIcon
